import { render, staticRenderFns } from "./loadingIcon.vue?vue&type=template&id=644d3b7c"
import script from "./loadingIcon.vue?vue&type=script&lang=js"
export * from "./loadingIcon.vue?vue&type=script&lang=js"
import style0 from "./loadingIcon.vue?vue&type=style&index=0&id=644d3b7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports